(function () {
  /* ---- Re-entry guard ----------------------------------------------------
     This file used to be emitted by shocksims-fitment-widget.liquid, which
     theme.liquid renders globally. Any page that also rendered the snippet
     inline got two <script src> tags for this file, so the whole IIFE ran
     twice: two document-level click listeners, two Escape listeners, and a
     second private SS_MODALS array that stayed empty. It happened to keep
     working through luck of script ordering, which is not a guarantee worth
     relying on. The script tag now lives in 'shocksims-fitment-assets' and
     is rendered once, and this guard makes a repeat include harmless.
     -------------------------------------------------------------------- */
  if (window.__ssFitWidgetLoaded) return;
  window.__ssFitWidgetLoaded = true;

  /* ══════════════════════════════════════════════════════════════════════
     EDITABLE BLOCK  —  everything you'd ever change is between these banners
     ══════════════════════════════════════════════════════════════════════ */

  var SS_FIT_WORKER_URL = "https://shocksims-rpo-worker.xineering.workers.dev/?vin=";
  var CONTACT_URL   = "https://shocksims.com/pages/contact";
  var SUPPORTED_URL = "https://shocksims.com/pages/supported-vehicles";
  var ALC_VIDEO_URL = "https://www.youtube.com/watch?v=ocID3LLa56k";

  /* ---- GM factory window sticker ----
     When the RPO service cannot decode a VIN (typically a brand-new model year
     not in the database yet), GM still publishes the factory window sticker,
     which lists every RPO. We offer it as a fallback for GM VINs from 2021 on,
     the range where this link format is known to work. The page it loads is a
     PDF, and it is appended with the VIN, url-encoded. ---- */
  var WINDOW_STICKER_URL = "https://cws.gm.com/vs-cws/vehshop/v2/vehicle/windowsticker?vin=";

  /* ---- Loading status hand-off ----
     The Worker tries DecoderPro first and, for a new-enough GM VIN it cannot
     read, falls back to the GM window sticker inside the SAME request. The widget
     can't observe that hand-off directly, but DecoderPro either answers quickly
     or not at all, so once this delay passes with no answer the sticker read must
     be underway and we update the status text to say so. Only armed for GM VINs
     from STICKER_HINT_MIN_YEAR on, which is the range the sticker fallback covers,
     so the message is never shown when no sticker lookup is actually happening. */
  var STICKER_HINT_MIN_YEAR = 2021;
  var STICKER_HINT_DELAY_MS = 8000;

  /* ---- GM VIN lookup coverage (interim, Oct 2026) ----
     The Worker now reads RPO codes only from the GM window sticker, which
     covers GM VINs from this model year on. Older GM VINs come back with no
     codes, and the widget says so plainly instead of "could not read".
     Lower this the day a source for older years is added to the Worker. ---- */
  var GM_VIN_MIN_YEAR = 2021;

  /* ---- Pre-2015 MagneRide has no module. This is the load resistor we
         point those customers at in support. ---- */
  var RESISTOR_URL = "https://www.amazon.com/dp/B00L4V9ECY?linkCode=ll2&tag=xineeringllc-20";

  /* ---- Live product data ----
     The Liquid snippet writes the real title, price, image and URL for each
     product into a JSON tag on the page. Set SHOW_PRICE to true if you want
     the live price shown next to the module name. Prices are never hardcoded
     here, so they cannot go stale. SHOW_IMAGE controls the thumbnail. ---- */
  var SHOW_PRICE = true;
  var SHOW_IMAGE = true;

  /* ---- Future products: flip to true the day each goes live ----
     ELITE_V2: the 2025+ air ride SUV module, sold as the "2025+ | EliteV2"
     variant of the OBD/SS Elite (Sep 2026). Set it to false and 2025+ F47 SUVs
     go back to the "no module yet" message. ---- */
  var ENABLED = { APEX: true, LEGACY: true, ELITE_V2: true };

  /* ---- Adaptive Ride Control (RPO Z45) was introduced in 2019 and is still
         current on High Country and Sierra Denali 1500 trucks, gas and
         diesel. Nothing older than this year is an ARC truck. ---- */
  var ARC_MIN_YEAR = 2019;

  /* ---- Ford and Lincoln support for the OBD/SS Ford VDM-E. Decoderpo is
         GM only, so we never call the Worker for these. Year comes straight
         off the VIN and the outer range gates the recommendation. ---- */
  var FORD_SUPPORT = { minYear:2015, maxYear:2023 };

  /* ---- Make detection from the WMI (first 3 VIN characters) ----
     GM is the ONLY make we send to the Worker, because decoderpo.com only
     returns RPO data for GM. Ford and Lincoln are answered locally. Any
     other make gets an unsupported message with no network call at all. */
  var WMI_MAKES_3 = {
    "1LN": "LINCOLN", "5LM": "LINCOLN", "5LT": "LINCOLN",
    "WF0": "FORD", "NM0": "FORD", "6FP": "FORD"
  };
  var WMI_MAKES_2 = {
    "1F": "FORD", "2F": "FORD", "3F": "FORD",
    "1G": "GM", "2G": "GM", "3G": "GM", "KL": "GM", "6G": "GM"
  };

  /* ---- Every suspension-related RPO we explain to the customer ----
     label  = short name shown next to the code
     detail = one plain sentence describing what it actually does
     group  = "active" (we may have a module) | "air" | "passive" | "package"

     Sourcing note: GM bulletin PI0430C lists F55, Z55 and Z95 together as
     Magnetic Ride Control for 2006-2014, so no description here should tell
     a customer their build is "not magnetic". Z85 has been reused by GM
     under several names over the years, so its description stays vague and
     the air question is answered by the routing logic instead. ---- */
  var SUSPENSION_CODES = {
    Z95: { group:"active", label:"MagneRide",
      detail:"Magnetically controlled shocks at all four corners, run by the Suspension Control Module (SCM). Removing them sets a \u201CService Suspension\u201D message and a speed limiter." },
    F55: { group:"active", label:"Magnetic Ride Control",
      detail:"Magnetically controlled shocks, the same technology GM also brands MagneRide. This is the code used on the Camaro and on most Cadillac cars." },
    FE2: { group:"active", label:"Magnetic Ride Control (base Stingray)",
      detail:"Base Corvette Stingray suspension upgraded with Magnetic Ride Control." },
    FE4: { group:"active", label:"Magnetic Ride Control (Z51 or Grand Sport)",
      detail:"Z51 or Grand Sport performance suspension upgraded with Magnetic Ride Control." },
    FE6: { group:"active", label:"Magnetic Ride Control (Z06)",
      detail:"Z06 performance suspension. MagneRide is standard on this build." },
    FE7: { group:"active", label:"Magnetic Ride Control (Z07)",
      detail:"Z07 track suspension. MagneRide is standard on this build." },
    Z55: { group:"active", label:"Autoride",
      detail:"The pre-2015 electronically controlled shock system, with rear air leveling and a compressor. On many builds these shocks are magnetic, which is why GM lists Z55 alongside MagneRide." },
    F45: { group:"passive", label:"Real Time Damping",
      detail:"Electronically controlled valve type shocks. Adjustable damping, but not magnetic." },
    Z45: { group:"active", label:"Adaptive Ride Control",
      detail:"Electronically controlled shocks and struts on GM 1500 trucks, run by the Suspension Control Module (SCM)." },
    F47: { group:"air", label:"Air Ride Adaptive Suspension",
      detail:"Air shocks at all four corners plus a compressor, accumulator, manifold and the Automatic Level Control Module (ALCM). On the SUVs we support it always comes with MagneRide." },
    G69: { group:"air", label:"Automatic Level Control",
      detail:"Rear air shocks with a compressor that levels the vehicle when you load it or hook up a trailer." },
    ZW7: { group:"passive", label:"Premium Smooth Ride",
      detail:"Self-leveling Nivomat rear shocks. There is no electronics and no compressor, so no module is needed." },
    Z71: { group:"passive", label:"Off-road suspension",
      detail:"Conventional monotube shocks with heavier springs. Not electronically controlled." },
    Z66: { group:"passive", label:"On-road suspension",
      detail:"Conventional street shocks. Not electronically controlled." },
    Z83: { group:"passive", label:"Solid ride suspension",
      detail:"Conventional twin-tube shocks. Not electronically controlled." },
    Z85: { group:"package", label:"Suspension package",
      detail:"A chassis and spring package. GM has used this code under several names over the years, so on its own it does not tell you whether the vehicle has air leveling." },
    F51: { group:"passive", label:"Heavy duty shock absorbers",
      detail:"Conventional heavy duty shocks. Not electronically controlled." }
  };

  /* ══════════════════════════════════════════════════════════════════════
     THE HARD SUPPORT GATE  —  MagneRide codes are NOT global
     ══════════════════════════════════════════════════════════════════════
     GM reuses the same three character codes on completely different
     platforms, so a code only means MagneRide inside the body style and
     year window where GM used it that way. Reading them globally is what
     made a 2016 GMC Terrain with FE2 come back as a MagneRide vehicle.

       FE2, FE4, FE6, FE7  Corvette only. On every other GM vehicle these
                           are plain ride and handling suspension codes.
       F55                 Cars only (Camaro, ATS, CTS, XTS, Chevrolet SS).
                           Never used on SUVs or trucks.
       Z95                 Trucks and SUVs, 2015 and newer. Also on some pre-2015
                           builds, where it is magnetic legacy MagneRide: pre-2015
                           SUVs may take the Legacy module, while pre-2015 trucks
                           get the DIY resistor bypass only (module is SUV-only).
                           Also on the late Cadillac cars we support.
       Z55                 2007-2014 only. Ignored entirely on 2015+.
       Z45                 Adaptive Ride Control, 1500 trucks, 2019+.
     ────────────────────────────────────────────────────────────────────── */
  var ARC_CODE       = "Z45";
  /* pre-2015 MagneRide / Autoride codes (magnetic). Both Z55 (Autoride) and Z95
     turn up on pre-2015 builds, and both are magnetic, so converting to
     conventional shocks always needs a bypass. hasLegacy uses this list to route
     a pre-2015 TRUCK to the DIY resistor tip. It never grants a module: the
     OBD/SS Legacy MODULE stays SUV-only. Pre-2015 SUVs read MagneRide through
     MR_CODES_SUV_LEGACY, pre-2015 cars through MR_CODES_CAR. */
  var LEGACY_MR_CODES = ["Z55", "Z95"];

  var MR_CODES_CORVETTE   = ["FE2", "FE4", "FE6", "FE7", "F55"];
  var MR_CODES_CAR        = ["F55", "Z95"];
  var MR_CODES_MODERN     = ["Z95"];            // trucks and SUVs, 2015+
  /* 2007-2014 SUVs only. Most of this era used Z55 (Autoride); the later years
     began switching to Z95, and by 2015 every SUV uses Z95 (MR_CODES_MODERN).
     F55 is a car code and never appears on an SUV, so it is NOT in this list. */
  var MR_CODES_SUV_LEGACY = ["Z55", "Z95"];

  /* ---- 2007-2014 SUVs: MagneRide in this era always came with rear air
         leveling, and G69 is the standalone Automatic Level Control code.
         F55 is a car code and never appears on an SUV, so it is not here. ---- */
  var LEGACY_AIR_CODES = ["Z55", "Z95", "G69"];

  /* ---- Which body style and year window each code is allowed to speak in.
         Used for BOTH the recommendation and the code list we print back to
         the customer, so a Terrain never sees "base Stingray" on its screen.
         Any code not listed here is always shown. ---- */
  var CODE_SCOPE = {
    FE2: function(c){ return c.isCorvette; },
    FE4: function(c){ return c.isCorvette; },
    FE6: function(c){ return c.isCorvette; },
    FE7: function(c){ return c.isCorvette; },
    F55: function(c){ return c.body === "car"; },   // cars only; never SUV/truck
    Z55: function(c){ return c.year && c.year <= 2014; },
    Z45: function(c){ return c.body === "truck" && c.year && c.year >= ARC_MIN_YEAR; }
  };

  /* ---- Engine by VIN position 8 (index 7). fuel decides ARC vs ARC-MAX ---- */
  var ENGINE_BY_VIN8 = {
    D: { fuel:"gas",    label:"5.3L V8" },
    H: { fuel:"gas",    label:"2.7L I4" },
    L: { fuel:"gas",    label:"6.2L V8" },
    T: { fuel:"diesel", label:"3.0L Duramax I6" },
    "8": { fuel:"diesel", label:"3.0L Duramax I6" }
  };

  /* ---- NOTE: the old ARC_TRIM_BY_VIN5 fallback has been removed on
         purpose. It recommended an ARC product off VIN position 5 alone, so
         a High Country or Denali WITHOUT Adaptive Ride Control still got a
         module. Z45 is now required, no exceptions. ---- */

  /* ---- Body type from the scraped vehicle title. Cars, trucks and SUVs
         run through completely separate gates below. ---- */
  var BODY_PATTERNS = [
    [/silverado|sierra|colorado|canyon/i, "truck"],
    [/tahoe|suburban|yukon|escalade|avalanche|traverse|acadia|enclave|terrain|equinox|trailblazer|blazer|trax|encore|envision|envista|\bxt4\b|\bxt5\b|\bxt6\b|\bsrx\b/i, "suv"],
    [/camaro|corvette|\bcts\b|\bct4\b|\bct5\b|\bct6\b|\bats\b|\bxts\b|\bsts\b|\bdts\b|chevrolet\s+ss\b|impala|malibu|cruze|regal|lacrosse|verano|caprice|lucerne/i, "car"]
  ];

  /* ---- CAR SUPPORT TABLE ----
     Cars do not follow the SUV platform pattern, so they get their own
     table straight off the supported-vehicles sheet. First match wins, so
     keep the Camaro rule above the Chevrolet SS rule. A rule only fires if
     the build actually carries a MagneRide code. Any car that does not
     match a rule is not supported and never will be. ---- */
  var CAR_RULES = [
    { test:/camaro/i,          minYear:2012, maxYear:2023, product:"CLASSIC", mr:["F55"] },
    { test:/corvette/i,        minYear:2014, maxYear:2019, product:"CLASSIC", mr:MR_CODES_CORVETTE },
    { test:/corvette/i,        minYear:2020,               product:"CARBON",  mr:MR_CODES_CORVETTE },
    { test:/\bct4\b|\bct5\b/i, minYear:2020, maxYear:2024, product:"CARBON",  mr:["Z95","F55"] },
    { test:/\bats\b/i,         minYear:2013, maxYear:2019, product:"CLASSIC", mr:["F55"] },
    { test:/\bcts\b/i,         minYear:2014, maxYear:2019, product:"CLASSIC", mr:["F55"] },
    { test:/\bxts\b/i,         minYear:2013, maxYear:2019, product:"CLASSIC", mr:["F55"] },
    { test:/chevrolet\s+ss\b/i,minYear:2015, maxYear:2017, product:"CLASSIC", mr:["F55"] }
  ];

  /* ---- TRUCK MagneRide range. Sierra Denali carried MagneRide before
         Adaptive Ride Control took over in 2019. Trucks NEVER get the
         Carbon, which is an SUV and car module. ---- */
  var TRUCK_MR_RANGE = { minYear:2015, maxYear:2020, product:"CLASSIC" };

  /* ---- SUV year boundaries ----
         The Legacy covers 2007-2014 SUVs only. Anything older than 2007 has
         no module and no plans for one, so it goes straight to the resistor
         method with no tester offer. ---- */
  var SUV_LEGACY_RANGE  = { minYear:2007, maxYear:2014 };
  var SUV_CLASSIC_RANGE = { minYear:2015, maxYear:2020 };
  /* The Elite covers every 2021+ air ride SUV. It is one product with two
     versions: 2021-2024 takes the Elite, ELITE_V2_MIN_YEAR and newer takes the
     EliteV2. No maxYear, so each new model year is covered with no edit. */
  var SUV_ELITE_RANGE   = { minYear:2021 };
  var ELITE_V2_MIN_YEAR = 2025;

  /* ---- Products ---- */
  var PRODUCTS = {
    CLASSIC: { name:"OBD/SS Classic", handle:"obd-ss-classic-magneride-bypass",
      url:"https://shocksims.com/products/obd-ss-classic-magneride-bypass",
      blurb:"Suppresses the MagneRide shock fault codes so the vehicle stops reporting the missing shocks.",
      blurbAir:"Suppresses the MagneRide shock fault codes. It does not touch the air leveling system.",
      cta:"View the OBD/SS Classic" },
    CARBON: { name:"OBD/SS Carbon", handle:"obd-ss-carbon-magneride-bypass",
      url:"https://shocksims.com/products/obd-ss-carbon-magneride-bypass",
      blurb:"Talks to the Suspension Control Module (SCM) so it stops reporting the missing MagneRide shocks.",
      blurbAir:"For 2021 and newer GM SUVs with MagneRide (RPO Z95) and no air ride.",
      cta:"View the OBD/SS Carbon" },
    ELITE: { name:"OBD/SS Elite", handle:"obd-ss-elite-gm-suv-suspension-bypass",
      url:"https://shocksims.com/products/obd-ss-elite-gm-suv-suspension-bypass",
      blurb:"For 2021 and newer GM SUVs with Air Ride Adaptive Suspension (RPO F47). Deletes the MagneRide shocks and the entire air system.",
      cta:"View the OBD/SS Elite",
      /* No variants map on purpose: the fitment result always links to the
         main Elite product page, never a variant and never the standalone
         EliteV2 listing. The note under the result tells them which year to
         pick there. The variant name only changes the title shown, so a 2025
         SUV reads "OBD/SS EliteV2", the same way a 2023 truck reads ARC-R. */
      variantNames:{ ELITE_V2:"OBD/SS EliteV2" } },
    ARC: { name:"OBD/SS ARC", handle:"obd-ss-arc-adaptive-ride-control-bypass",
      url:"https://shocksims.com/products/obd-ss-arc-adaptive-ride-control-bypass",
      blurb:"For GM 1500 trucks with Adaptive Ride Control and a gasoline engine.",
      cta:"View the OBD/SS ARC",
      variants:{ ARC_2019_2021:"44802046132412", ARC_2022:"45195967692988", ARC_R_2023:"45195965399228" },
      /* Shown instead of the parent product title when that variant is the
         recommendation, so a 2023 truck is told it needs the ARC-R. */
      variantNames:{ ARC_R_2023:"OBD/SS ARC-R" },
      autofillVinFor:["ARC_2022"] },
    ARC_MAX: { name:"ARC-MAX", handle:"arc-max-shock-sims-duramax",
      url:"https://shocksims.com/products/arc-max-shock-sims-duramax",
      blurb:"For GM Duramax 1500 trucks with Adaptive Ride Control.",
      cta:"View the ARC-MAX" },
    VDME: { name:"OBD/SS Ford VDM-E", handle:"vdm-e-ford-vehicle-dynamics-emulator",
      url:"https://shocksims.com/products/vdm-e-ford-vehicle-dynamics-emulator",
      blurb:"Fully emulates the OEM Vehicle Dynamics Module on Ford and Lincoln vehicles with the MagneRide Damping System.",
      cta:"View the OBD/SS Ford VDM-E" },
    APEX: { name:"OBD/SS Apex", handle:"obd-ss-apex-gm-suv-suspension-bypass",
      url:"https://shocksims.com/products/obd-ss-apex-gm-suv-suspension-bypass",
      blurb:"For 2015-2020 GM SUVs with MagneRide (RPO Z95). Emulates the Suspension Control Module so the MagneRide shocks and the entire air system can come off the vehicle.",
      cta:"View the OBD/SS Apex" },
    LEGACY: { name:"OBD/SS Legacy", handle:"obd-ss-legacy-magneride-bypass",
      url:"https://shocksims.com/products/obd-ss-legacy-magneride-bypass",
      blurb:"For 2007-2014 GM SUVs with MagneRide. The Suspension Control Module (SCM) comes out and the Legacy emulates it, so the MagneRide shocks and the entire air system can come off the vehicle. If you plan on towing we strongly suggest keeping OE shocks.",
      cta:"View the OBD/SS Legacy" }
  };

  /* ---- Reusable notes. Each is { text, link? } ---- */
  var NOTES = {
    alc_bypass: { text:"If you remove the rear air shocks, the air lines have to be looped back so the compressor can still pass its self test. Otherwise you will get a \u201CService Leveling System\u201D message.",
      link:{ href:ALC_VIDEO_URL, label:"Watch the ALC air circuit bypass video" } },
    classic_keeps_air: { text:"Keep the Automatic Level Control module and compressor powered and working. You can replace just the front MagneRide shocks and leave the rear air alone, or replace all four and bypass the air lines." },
    /* ---- Used on the 2015-2020 SUV path once the OBD/SS Apex is live. The
           Classic is the keep the air option there, so it never carries the
           air line loop wording or the ALC bypass video. A customer who wants
           the air gone is pointed at the Apex instead. ---- */
    classic_keeps_air_apex: { text:"Keep the Automatic Level Control module and compressor powered and working. Replace just the front MagneRide shocks and leave the rear air shocks in place." },
    rhs_needed: { text:"If you lift or lower the vehicle, you will also need Ride Height Simulators so the module reports a normal ride height." },
    apex_no_rhs: { text:"No Ride Height Simulators are needed. The Apex fully emulates the suspension, including ride height, so you can lift or lower the vehicle without extra parts." },
    towing_air: { text:"If you tow more than about 2,000 lbs, we suggest keeping the rear air shocks." },
    apex_deletes_air: { text:"The whole air system comes out: rear air shocks, compressor, lines and the leveling module. Nothing left to service." },
    apex_coming: { text:"We are building a module that deletes the air system on this platform as well (OBD/SS Apex). It is not available yet." },
    /* ---- OBD/SS Legacy. Full SCM emulation, so it never carries the Ride
           Height Simulator note and never carries the air line loop note. */
    legacy_full_emulation: { text:"The Legacy fully emulates the Suspension Control Module (SCM), including ride height and the air system. No Ride Height Simulators are needed even if you lift or lower the vehicle, and the whole air system can come out. You do not need to loop the air lines or keep the compressor alive." },
    legacy_all_four: { text:"The factory Suspension Control Module (SCM) is removed and its fuse is pulled, so all four shocks have to be replaced at the same time. You cannot do just the front or just the rear on this platform." },
    legacy_tester: { text:"We are looking for testers on this platform right now. Testers get the module early and help us confirm fitment on real vehicles before it goes on sale. Send us your VIN and tell us what you are planning to run.",
      link:{ href:CONTACT_URL, label:"Contact us about testing" } },
    front_or_rear_sets: { text:"Shocks can be changed front or rear as a set. You do not have to do all four at once on this platform." },
    air_all_four: { text:"All four air shocks must be replaced at once. Removing just one breaks the air system." },
    /* ---- Tells the customer which year option to pick on the Elite page,
           since the result links to the product page with no variant chosen. */
    elite_pick_v1: { text:"On the product page, choose your model and the \u201C2021-2024 | Elite\u201D year option." },
    elite_pick_v2: { text:"On the product page, choose your model and the \u201C2025+ | EliteV2\u201D year option." },
    carbon_no_f47: { text:"This module is for MagneRide only. If your SUV also has Air Ride Adaptive Suspension (RPO F47) it is the wrong part and will set codes." },
    arc_2022: { text:"2022 is a transition year, tapping the button above will pre-fill your VIN on the product page to confirm whether you need the ARC or the ARC-R." },
    arc_rhs: { text:"Once the Suspension Control Module is unpowered by pulling fuse F56 (SADS 15A), the three ride height sensors can be removed entirely." },
    /* ---- ARC-MAX is external and passive. The Suspension Control Module
           stays powered, so the ride height sensors have to stay. ---- */
    arcmax_rhs: { text:"Keep all three ride height sensors connected. They stay in place with the ARC-MAX and get zip tied at mid travel, and we include the zip ties with the kit." },
    ford_models: { text:"The OBD/SS Ford VDM-E covers the Lincoln Navigator 2015-2023, the Mustang Shelby GT350 2015-2023 and the Mustang Shelby GT500 2020-2022. It does not cover the base Mustang GT." },
    speed_limiter: { text:"MagneRide platforms drop into a speed limiter when a shock fault is stored, so a module is not optional if you are removing the shocks." },
    nivomat_springs: { text:"Swapping the Nivomat rear shocks for conventional shocks also means changing the rear springs, or the back end will sag." },
    air_keep_intact: { text:"If your vehicle has rear air leveling, keep the compressor powered and operational. If you remove the air shocks, loop the air lines back so the compressor can still run its self test." },
    /* ---- pre-2015 resistor method ---- */
    z55_resistors: { text:"Until it is ready, here is the bypass we suggest for the shocks and the rear air leveling. The method we suggest is 50W 6 ohm load resistors soldered inline to the two wire shock harness, one per shock.",
      link:{ href:RESISTOR_URL, label:"See the load resistors we recommend" } },
    z55_ziptie: { text:"Zip tie each ride height position sensor in its stock position. This is the step people skip, and skipping it will blow the resistors on a regular basis." },
    z55_why: { text:"The resistors stand in for the magnetic coil in the shock, and the Suspension Control Module decides how much current to send based on speed, steering angle, brake pressure and ride height. Ride height is the biggest input and updates every 25 milliseconds, so holding it steady keeps the current down." },
    resistor_overcurrent: { text:"Even with the sensors tied off, the module can still send up to 5 amps to a shock during hard braking or a sharp turn at speed, so resistor based simulators can eventually fail. That is why we build electronic modules for the platforms we support." },
    suv_air_no_mr: { text:"If it has rear air leveling, keep the compressor powered and operational and loop the air lines back so it can pass its self test.",
      link:{ href:ALC_VIDEO_URL, label:"Watch the ALC air circuit bypass video" } }
  };

  /* ---- Messages for non-product outcomes ---- */
  var MESSAGES = {
    /* SUVs */
    suv_pre2015_no_module: "There is no module for MagneRide this old. On these SUVs MagneRide always came with rear air leveling, so here is the bypass we suggest for both the shocks and the air system.",
    /* Only shown when ENABLED.ELITE_V2 is false. */
    suv_air_2025_plus:     "Your SUV has Air Ride Adaptive Suspension (RPO F47). We do not have an OBD module for 2025 and newer air ride SUVs yet. We are testing a mechanical solution on a 2025 Suburban right now.",
    apex_not_live:         "Your SUV has MagneRide, which on this platform always comes with rear air leveling. The OBD/SS Classic handles the MagneRide side today.",
    legacy_era:            "Your SUV has MagneRide, which on this platform always comes with rear air leveling. The OBD/SS Legacy emulates the Suspension Control Module, so the shocks and the entire air system can come off.",
    legacy_tester_wanted:  "Good news. Your SUV is exactly what the OBD/SS Legacy is being built for: a 2007-2014 GM SUV with MagneRide. It is not on sale yet and we are still testing.",
    suv_no_magneride:      "Your SUV does not have MagneRide, so there is nothing electronic to bypass and you do not need a module. Replace the shocks with any brand you like.",
    /* Cars and trucks */
    car_not_supported:     "This car does not have a suspension we build a module for. Our car coverage is limited to MagneRide equipped models on our supported vehicles list.",
    car_no_magneride:      "This car does not have MagneRide, so there is nothing electronic to bypass and you do not need a module. Replace the shocks or struts with any brand you like.",
    f45_oem_only:          "This vehicle has Real Time Damping (RPO F45), electronically controlled valve type shocks. We do not build a module for it. Fitting conventional shocks on their own will set a \u201CService Suspension System\u201D message, because the Suspension Control Module still expects the F45 dampers. A load resistor bypass is possible on some F45 vehicles, but not all. GM used this code on very different systems over the years, so the correct setup changes with the make, model and year. Keeping the OEM shocks is the simplest path. If you plan to convert, the resistor value has to be matched to your specific vehicle.",
    truck_no_magneride:    "This truck does not have MagneRide or Adaptive Ride Control, so there is nothing electronic to bypass and you do not need a module. Replace the shocks with any brand you like.",
    truck_pre2015:         "There is no module for pre-2015 MagneRide, which GM lists as RPO Z55. Here is the bypass we suggest instead.",
    car_pre2015:           "There is no module for MagneRide this old, and none is planned. Here is the bypass we suggest instead.",
    /* Ford and Lincoln */
    ford_out_of_range:     "We build the OBD/SS Ford VDM-E for the MagneRide Damping System, but this model year falls outside the vehicles we cover.",
    /* Passive builds */
    nivomat_no_module:     "Your vehicle has Premium Smooth Ride (RPO ZW7) with self-leveling Nivomat rear shocks. There is nothing electronic to bypass, so you do not need a module.",
    traditional_no_module: "Your vehicle has conventional shocks with no MagneRide and no Adaptive Ride Control, so you do not need a module. Replace the shocks with any brand you like.",
    /* Decode problems. These are the only places we ask for a VIN. */
    year_unknown:          "We could not read the model year for this VIN. Contact us and we will confirm fitment for you.",
    unsupported_make:      "We could not read this VIN as a supported vehicle. Our products cover GM MagneRide and Adaptive Ride Control platforms, plus select Ford and Lincoln.",
    no_decode:             "We could not read the factory build for this VIN. Please double-check it, or contact us and we will help.",
    body_unknown:          "We read the factory build for this VIN but could not match the model to one of our platforms. Contact us with your VIN and we will confirm it by hand.",
    window_sticker_hint:   "We could not read the factory window sticker for this VIN automatically. You can open it yourself and look for “MAGNETIC RIDE CONTROL” in the options list.",
    gm_pre_coverage:       "VIN lookup currently reads factory options for 2021 and newer GM vehicles only, so we cannot confirm this one from the VIN. Check the supported vehicles list, or contact us with your VIN and we will confirm fitment by hand."
  };

  var STATUS_FALLBACK = {
    needs_vin:   "We could not confirm this one automatically. Please contact us and we will sort it out.",
    unsupported: "We do not support this vehicle yet. Please contact us for current status.",
    diy:         "We do not build a module for this vehicle, but here is what we suggest.",
    no_module:   "You do not need one of our modules for this vehicle. Replace the shocks with any brand you like."
  };

  var T = {
    recommendedEyebrow: "Recommended module",
    twoOptionsEyebrow:  "Two ways to go",
    buildEyebrow:       "Your factory suspension",
    airEyebrow:         "Air leveling",
    contactText:        "Contact us",
    supportedText:      "See all supported vehicles",
    loading:            "Reading your factory build\u2026",
    loadingSticker:     "Checking the GM window sticker\u2026",
    badVin:             "That is not a valid VIN. A VIN is 17 characters and never contains I, O or Q.",
    unreachable:        "We could not reach the fitment service. Try again in a moment.",
    modalTitle:         "Find your module by VIN",
    coverageNote:       "VIN lookup covers 2021 and newer GM vehicles, plus supported Ford and Lincoln. For older GM vehicles, see the supported vehicles list or contact us.",
    windowStickerLink:  "View the GM window sticker"
  };

  /* ---- Codes we read for air detection but never show the customer,
         because they are not suspension options. ---- */
  var INFER_ONLY = { Z82:"Trailering equipment" };
  // NHT (Max Trailering Package) is deliberately not used at all.

  /* ---- Test scenarios. Add ?ssfit_debug=1 to any page URL to get a row of
         buttons that push these straight through the real logic, with no
         Worker call. Nothing renders without that URL flag. ---- */
  var TEST_CASES = [
    { name:"2018 Tahoe Z95 SUV",       vin:"1GNSKCKC3JR000001", year:2018, vehicle:"2018 Chevrolet Tahoe Premier", trim:"Premier", codes:["Z95","Z85","NHT","Z82"] },
    { name:"2016 Yukon no MagneRide",  vin:"1GKS2GKC0GR000001", year:2016, vehicle:"2016 GMC Yukon SLE",          trim:"SLE",     codes:["Z85","NHT","Z82"] },
    { name:"2018 Tahoe Z71 passive",   vin:"1GNSKBKC0JR000001", year:2018, vehicle:"2018 Chevrolet Tahoe LT",     trim:"LT",      codes:["Z71","Z85"] },
    { name:"2017 Yukon ZW7 Nivomat",   vin:"1GKS2BKC0HR000001", year:2017, vehicle:"2017 GMC Yukon SLT",          trim:"SLT",     codes:["ZW7","Z85"] },
    { name:"2020 Escalade Z95",        vin:"1GYS4CKJ0LR000001", year:2020, vehicle:"2020 Cadillac Escalade",      trim:"Luxury",  codes:["Z95","Z85"] },
    { name:"2012 Escalade Z55 pre-15", vin:"1GYS4CEF0CR000001", year:2012, vehicle:"2012 Cadillac Escalade",      trim:"Luxury",  codes:["Z55"] },
    { name:"2010 Tahoe Z55 Autoride",  vin:"1GNUKCE00AR000001", year:2010, vehicle:"2010 Chevrolet Tahoe LTZ",    trim:"LTZ",     codes:["Z55","G69"] },
    { name:"2014 Tahoe Z95 legacy era",vin:"1GNSKCE00ER000001", year:2014, vehicle:"2014 Chevrolet Tahoe LTZ",    trim:"LTZ",     codes:["Z95"] },
    { name:"2011 Yukon F55 (car code on SUV)",vin:"1GKS2CE00BR000001", year:2011, vehicle:"2011 GMC Yukon Denali", trim:"Denali",  codes:["F55","G69"] },
    { name:"2005 Tahoe (too old)",     vin:"1GNEK13T05R000001", year:2005, vehicle:"2005 Chevrolet Tahoe LT",     trim:"LT",      codes:["Z55"] },
    { name:"2012 Yukon no MagneRide",  vin:"1GKS2AE00CR000001", year:2012, vehicle:"2012 GMC Yukon SLE",          trim:"SLE",     codes:["Z85"] },
    { name:"2022 Tahoe Z95 only",      vin:"1GNSKNKD0NR000001", year:2022, vehicle:"2022 Chevrolet Tahoe RST",    trim:"RST",     codes:["Z95"] },
    { name:"2022 Suburban Z95 + F47",  vin:"1GNSKKKD0NR000001", year:2022, vehicle:"2022 Chevrolet Suburban High Country", trim:"High Country", codes:["Z95","F47"] },
    { name:"2025 Suburban F47 (EliteV2)", vin:"1GNSKKKD0SR000001", year:2025, vehicle:"2025 Chevrolet Suburban High Country", trim:"High Country", codes:["Z95","F47"] },
    { name:"2024 Yukon XL F47 (Elite)",   vin:"1GKS2KKL0RR000001", year:2024, vehicle:"2024 GMC Yukon XL Denali Ultimate", trim:"Denali Ultimate", codes:["Z95","F47"] },
    { name:"2026 Escalade ESV F47 (EliteV2)", vin:"1GYS4PKL0TR000001", year:2026, vehicle:"2026 Cadillac Escalade ESV", trim:"Sport Platinum", codes:["Z95","F47"] },
    { name:"2025 Tahoe Z95 no air",    vin:"1GNSKNKD0SR000001", year:2025, vehicle:"2025 Chevrolet Tahoe RST",    trim:"RST",     codes:["Z95"] },
    { name:"2021 C8 Corvette FE4",     vin:"1G1YA2D40M5000001", year:2021, vehicle:"2021 Chevrolet Corvette Stingray", trim:"1LT", codes:["FE4"] },
    { name:"2021 C8 Corvette passive", vin:"1G1YA2D40M5000002", year:2021, vehicle:"2021 Chevrolet Corvette Stingray", trim:"1LT", codes:["FE1"] },
    { name:"2017 C7 Corvette FE4",     vin:"1G1YM2D70H5000001", year:2017, vehicle:"2017 Chevrolet Corvette Grand Sport", trim:"3LT", codes:["FE4"] },
    { name:"2016 C7 Z06 FE7",          vin:"1G1YS2D66G5000001", year:2016, vehicle:"2016 Chevrolet Corvette Z06",  trim:"3LZ",    codes:["FE7"] },
    { name:"2008 Corvette (too old)",  vin:"1G1YY26W085000001", year:2008, vehicle:"2008 Chevrolet Corvette",      trim:"3LT",    codes:["F55"] },
    { name:"2022 Camaro ZL1 F55",      vin:"1G1FK1R60N0000001", year:2022, vehicle:"2022 Chevrolet Camaro ZL1",    trim:"ZL1",    codes:["F55"] },
    { name:"2016 Camaro SS F55",       vin:"1G1FF1R70G0000001", year:2016, vehicle:"2016 Chevrolet Camaro SS",     trim:"SS",     codes:["F55"] },
    { name:"2016 Chevrolet SS sedan",  vin:"6G3F15RW0G0000001", year:2016, vehicle:"2016 Chevrolet SS",            trim:"Base",   codes:["F55"] },
    { name:"2017 Cadillac XTS F55",    vin:"2G61M5S30H9000001", year:2017, vehicle:"2017 Cadillac XTS Luxury",     trim:"Luxury", codes:["F55"] },
    { name:"2023 CT5-V",               vin:"1G6DV5RP0P0000001", year:2023, vehicle:"2023 Cadillac CT5-V",          trim:"V",      codes:["Z95"] },
    { name:"2026 CT5 (out of range)",  vin:"1G6DV5RP0T0000001", year:2026, vehicle:"2026 Cadillac CT5-V",          trim:"V",      codes:["Z95"] },
    { name:"2017 Sierra Denali Z95",   vin:"3GTU2PEJ0HG000001", year:2017, vehicle:"2017 GMC Sierra 1500 Denali",  trim:"Denali", codes:["Z95"] },
    { name:"2020 Silverado ARC gas",   vin:"3GCUYHEDXLG000001", year:2020, vehicle:"2020 Chevrolet Silverado 1500 High Country", trim:"High Country", codes:["Z45"] },
    { name:"2022 Sierra ARC gas",      vin:"1GTU9FED0NZ000001", year:2022, vehicle:"2022 GMC Sierra 1500 Denali",  trim:"Denali", codes:["Z45"] },
    { name:"2023 Sierra ARC-R gas",    vin:"1GTUUGED0PZ000001", year:2023, vehicle:"2023 GMC Sierra 1500 Denali",  trim:"Denali", codes:["Z45"] },
    { name:"2023 Sierra Duramax",      vin:"1GTUUHET0PZ000001", year:2023, vehicle:"2023 GMC Sierra 1500 Denali",  trim:"Denali", codes:["Z45"] },
    { name:"2008 Sierra no codes",     vin:"1GTUUHET08Z000001", year:2008, vehicle:"2008 GMC Sierra 1500 SLT",     trim:"SLT",    codes:["Z85"] },
    { name:"Year unknown + Z95",       vin:"1GNSKCKC30R000001", year:null, vehicle:"Chevrolet Tahoe",              trim:null,     codes:["Z95"] },
    { name:"No suspension codes",      vin:"1GNSKBKC0JR000002", year:2018, vehicle:"2018 Chevrolet Tahoe LS",      trim:"LS",     codes:["G80","GU6"] },
    /* ---- regression cases for the code scoping fix ---- */
    { name:"2016 Terrain FE2 (car code on an SUV)", vin:"2GKFLVE30G6163304", year:2016, vehicle:"2016 GMC Terrain Denali", trim:"Denali", codes:["FE2","Z85"] },
    { name:"2018 Tahoe FE2 (car code on an SUV)",   vin:"1GNSKBKC0JR000003", year:2018, vehicle:"2018 Chevrolet Tahoe LT", trim:"LT",     codes:["FE2","Z85"] },
    { name:"2016 Sierra F55 (car code on a truck)", vin:"3GTU2PEJ0GG000001", year:2016, vehicle:"2016 GMC Sierra 1500 SLT", trim:"SLT",   codes:["F55","Z85"] },
    { name:"2021 High Country no Z45",              vin:"3GCUYHED0MG000001", year:2021, vehicle:"2021 Chevrolet Silverado 1500 High Country", trim:"High Country", codes:["Z85","Z71"] },
    { name:"2023 Denali no Z45",                    vin:"1GTUUGED0PZ000002", year:2023, vehicle:"2023 GMC Sierra 1500 Denali", trim:"Denali", codes:["Z85"] },
    { name:"2023 Denali Duramax no Z45",            vin:"1GTUUHET0PZ000002", year:2023, vehicle:"2023 GMC Sierra 1500 Denali", trim:"Denali", codes:["Z85"] },
    { name:"2019 Equinox (no platform)",            vin:"2GNAXHEV0K6000001", year:2019, vehicle:"2019 Chevrolet Equinox LT", trim:"LT",     codes:["FE2"] },
    { name:"2018 Malibu FE2 (car, unsupported)",    vin:"1G1ZD5ST0JF000001", year:2018, vehicle:"2018 Chevrolet Malibu LT",  trim:"LT",     codes:["FE2"] },
    { name:"2010 Tahoe G69 only",                   vin:"1GNUKBE00AR000001", year:2010, vehicle:"2010 Chevrolet Tahoe LT",   trim:"LT",     codes:["G69"] },
    /* ---- F45 Real Time Damping: OEM shocks only, any body ---- */
    { name:"2010 Cadillac DTS F45 (car)",           vin:"1G6KD57Y0AU000001", year:2010, vehicle:"2010 Cadillac DTS",        trim:"Luxury", codes:["F45"] },
    { name:"2002 Corvette F45 (C5 RTD car)",         vin:"1G1YY22G025000001", year:2002, vehicle:"2002 Chevrolet Corvette", trim:"Base", codes:["F45"] },
    { name:"F45 with year unknown",                 vin:"1G6KD57Y00U000001", year:null, vehicle:"Cadillac DTS",             trim:null,     codes:["F45"] },
    /* ---- pre-2015 magnetic shocks (Z55/Z95): always a bypass. Trucks get the
           DIY resistor tip, SUVs may take the Legacy module. ---- */
    { name:"2014 Sierra Z95 (pre-15 truck resistor)", vin:"3GTU2PEJ0EG000001", year:2014, vehicle:"2014 GMC Sierra 1500 Denali", trim:"Denali", codes:["Z95"] },
    { name:"2013 Escalade Z95 (pre-15 SUV)",        vin:"1GYS4CEF0DR000001", year:2013, vehicle:"2013 Cadillac Escalade",   trim:"Luxury", codes:["Z95","G69"] }
  ];

  /* ---- Air leveling explanations. Only ever shown on SUV paths. ---- */
  var AIR_SUMMARY = {
    f47:        "Air shocks at all four corners plus a compressor and a leveling module.",
    rear_air:   "Rear air leveling shocks with a compressor.",
    unknown:    "We cannot confirm rear air from the factory codes alone. A quick look under the rear bumper will tell you.",
    nivomat:    "Self-leveling Nivomat rear shocks. No compressor, no air lines.",
    none:       "No air leveling on this vehicle."
  };

  /* ══════════════════════════════════════════════════════════════════════
     END EDITABLE BLOCK  —  logic below rarely needs changing
     ══════════════════════════════════════════════════════════════════════ */

  var VIN_RE = /^[A-HJ-NPR-Z0-9]{17}$/;

  function esc(s){ return String(s == null ? "" : s).replace(/[&<>"]/g, function(c){
    return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]; }); }

  function detectMake(vin){
    var p3 = vin.slice(0,3), p2 = vin.slice(0,2);
    if (WMI_MAKES_3[p3]) return WMI_MAKES_3[p3];
    if (WMI_MAKES_2[p2]) return WMI_MAKES_2[p2];
    return null;
  }
  /* ---- Model year from VIN position 10 (index 9) ----
     The year code runs on a 30 year cycle: 21 letters (I, O, Q, U and Z are
     never used) then the digits 1 through 9.

       A B C D E F G H J K L M N P R S T V W X Y 1 2 3 4 5 6 7 8 9
       1980 .................................................. 2009
       2010 .................................................. 2039
       2040 ...

     So the same character means two different years 30 years apart. VIN
     position 7 (index 6) separates them: it is a digit on 1980-2009
     vehicles and a letter on 2010 and newer. We then take the newest cycle
     that is not in the future, so this keeps reading correctly when the
     letters restart at 2040 with no edit to the code. ---- */
  var VIN_YEAR_SEQ = "ABCDEFGHJKLMNPRSTVWXY123456789";

  function vinModelYear(vin){
    var idx = VIN_YEAR_SEQ.indexOf(String(vin[9] || "").toUpperCase());
    if(idx === -1) return null;

    // Position 7 numeric means the vehicle is from the 1980-2009 cycle.
    if(/^[0-9]$/.test(vin[6] || "")) return 1980 + idx;

    // Model years ship ahead of the calendar, so allow a two year lead.
    var maxYear = new Date().getFullYear() + 2;
    var year = 2010 + idx, best = year;
    while(year <= maxYear){ best = year; year += 30; }
    return best;
  }
  function classifyBody(title){
    if(!title) return null;
    for(var i=0;i<BODY_PATTERNS.length;i++) if(BODY_PATTERNS[i][0].test(title)) return BODY_PATTERNS[i][1];
    return null;
  }
  function has(codes,c){ return codes.indexOf(c) !== -1; }
  function hasAny(codes,list){
    for(var i=0;i<list.length;i++) if(has(codes,list[i])) return true;
    return false;
  }
  function inRange(year,rule){
    if(!year) return false;
    if(rule.minYear && year<rule.minYear) return false;
    if(rule.maxYear && year>rule.maxYear) return false;
    return true;
  }

  /* ---- Which codes are allowed to mean MagneRide on THIS vehicle ----
     Called with the body style, the model year and the decoded title. An
     empty list means we will never claim MagneRide, which is the correct
     answer for a model we could not classify. ---- */
  function mrCodesFor(body, year, title){
    var isCorvette = /corvette/i.test(title || "");
    if(body === "car") return isCorvette ? MR_CODES_CORVETTE : MR_CODES_CAR;
    if(body === "truck" || body === "suv"){
      if(year && year >= 2015) return MR_CODES_MODERN;          // Z95 only
      if(body === "suv" && year && year <= 2014) return MR_CODES_SUV_LEGACY;
      return LEGACY_MR_CODES;                                    // pre-2015 truck: magnetic (Z55/Z95), but resistor-only — never a module
    }
    return [];   // body unknown: never claim MagneRide
  }

  /* ---- Should this code be shown to the customer at all? ---- */
  function codeApplies(code, ctx){
    var rule = CODE_SCOPE[code];
    return rule ? !!rule(ctx) : true;
  }
  function scopeCtx(title, year){
    return { body:classifyBody(title), year:year, isCorvette:/corvette/i.test(title||"") };
  }
  /* ---- Build the "Your factory suspension" list, dropping any code that
         does not apply to this body style or year. ---- */
  function suspensionRows(codes, ctx){
    return (codes||[]).filter(function(c){
      return SUSPENSION_CODES[c] && codeApplies(c, ctx);
    }).map(function(c){
      var d = SUSPENSION_CODES[c];
      return { code:c, label:d.label, detail:d.detail, group:d.group };
    });
  }

  /* ---- Air leveling, SUVs only. Cars and trucks never get an air read,
         so the word "air" can never appear on those paths. ---- */
  function readSuvAir(codes, year, title){
    if(has(codes,"F47")) return "f47";
    // Confirmed: every 2015-2020 GM SUV with MagneRide (Z95) also has rear air.
    if(hasAny(codes,MR_CODES_MODERN) && year && year>=2015 && year<=2020) return "rear_air";
    // 2007-2014 SUVs: Autoride and the standalone Automatic Level Control code.
    if(hasAny(codes,LEGACY_AIR_CODES) && year && year<=2014) return "rear_air";
    if(has(codes,"G69")) return "rear_air";
    if(has(codes,"ZW7")) return "nivomat";
    // Z82 is trailering equipment, never reported, and only weak evidence
    // that air MIGHT be present. NHT is ignored entirely.
    if(has(codes,"Z82") && has(codes,"Z85") && year && year>=2015 && year<=2020) return "unknown";
    return "none";
  }

  /* ══════════════════════════════════════════════════════════════════════
     THE RECOMMENDATION ENGINE
     Support gate: a module is only ever offered when the build carries a
     MagneRide code or Adaptive Ride Control. Everything else gets advice.
     Cars, trucks and SUVs are routed by completely separate gates.
     ══════════════════════════════════════════════════════════════════════ */
  function recommend(o){
    var vin=o.vin||"", year=o.year, title=o.vehicleTitle||"", codes=o.codes||[];
    var char5=vin[4], char8=vin[7];
    var engine=ENGINE_BY_VIN8[char8]||null, fuel=engine?engine.fuel:null;
    var body=classifyBody(title);

    /* MagneRide is read through the body and year scoped list, never the
       whole code table. FE2 on a Terrain is a plain suspension package, not
       Magnetic Ride Control. */
    var mrCodes  = mrCodesFor(body, year, title);
    var hasMR    = hasAny(codes, mrCodes);
    var hasLegacy= hasAny(codes, LEGACY_MR_CODES) && year && year<=2014;
    var hasF47   = has(codes,"F47");
    /* Adaptive Ride Control is a hard code check. No trim character guess
       is allowed to put a truck on an ARC product. */
    var hasARC   = has(codes, ARC_CODE);
    // Air is an SUV concept only, and only on a confirmed SUV.
    var air = (body==="suv") ? readSuvAir(codes, year, title) : null;

    var signals={ bodyType:body, engine:engine?engine.label:null, fuel:fuel,
      hasMagneride:hasMR, mrCodesChecked:mrCodes, legacyMagneride:hasLegacy,
      hasF47:hasF47, hasARC:hasARC, air:air, vin5:char5, vin8:char8, year:year };

    function R(opts,status,reason,notes){
      return { options:opts||[], status:status, reason:reason, notes:notes||[], air:air, signals:signals };
    }
    function opt(product,extra){
      var o2={ product:product, variantKey:null, headline:null, useAirBlurb:false, notes:[] };
      if(extra) for(var k in extra) o2[k]=extra[k];
      return o2;
    }
    // The pre-2015 answer is the same everywhere: no module, use resistors.
    function resistorPath(reason){
      return R([],"diy",reason,["z55_resistors","z55_ziptie","z55_why","resistor_overcurrent"]);
    }

    /* ── F45 GATE: Real Time Damping, any body ───────────────────────────
       Real Time Damping (RPO F45) is electronically controlled valve type
       damping. We build no module for it, and unlike a passive build it must
       NOT be told to "fit any brand": the Suspension Control Module expects
       the F45 shocks and sets a Service Suspension System message if
       conventional shocks are installed, so only OEM F45 shocks will do.
       Unlike the MagneRide codes, F45 is not reused as a trim package on other
       platforms (it has no CODE_SCOPE entry), so it is safe to read globally,
       before the body and year gates. A build that also qualifies for a real
       module (MagneRide or Adaptive Ride Control) takes that recommendation
       instead, so those are excluded here. */
    if(has(codes,"F45") && !hasMR && !hasARC && !hasLegacy)
      return R([],"no_module","f45_oem_only",[]);

    if(!year) return R([],"needs_vin","year_unknown",[]);

    /* ── GATE 0: model we could not classify ─────────────────────────────
       Without a body style we cannot tell a suspension code from a trim
       package, so no product is ever offered here. */
    if(!body) return R([],"needs_vin","body_unknown",[]);

    /* ── GATE 1: Cars ────────────────────────────────────────────────────
       Cars run off their own table, and each rule carries the codes that
       actually mean MagneRide on that model. No air wording ever appears
       on a car path. */
    if(body==="car"){
      for(var i=0;i<CAR_RULES.length;i++){
        var rule=CAR_RULES[i];
        if(!rule.test.test(title)) continue;
        if(!hasAny(codes, rule.mr || mrCodes)) break;   // right car, no MagneRide
        if(!inRange(year,rule)) continue;               // right car, wrong year
        return R([opt(rule.product)],"ok","car_supported",["speed_limiter"]);
      }
      if(hasMR && year<=2014) return resistorPath("car_pre2015");
      if(!hasMR) return R([],"no_module","car_no_magneride",[]);
      return R([],"unsupported","car_not_supported",[]);
    }

    /* ── GATE 2: Trucks ──────────────────────────────────────────────────
       Adaptive Ride Control first, then the 2015-2020 MagneRide trucks.
       Trucks never take the Carbon and no truck path mentions air. */
    if(body==="truck"){
      if(hasARC && year>=ARC_MIN_YEAR){
        if(fuel==="diesel") return R([opt("ARC_MAX")],"ok","truck_diesel",["arcmax_rhs"]);
        if(year<=2021) return R([opt("ARC",{variantKey:"ARC_2019_2021"})],"ok","truck_gas_arc",["arc_rhs"]);
        if(year===2022) return R([opt("ARC",{variantKey:"ARC_2022"})],"ok","truck_gas_2022",["arc_2022","arc_rhs"]);
        return R([opt("ARC",{variantKey:"ARC_R_2023"})],"ok","truck_gas_arc",["arc_rhs"]);
      }
      if(hasMR && inRange(year,TRUCK_MR_RANGE))
        return R([opt(TRUCK_MR_RANGE.product)],"ok","truck_magneride",["speed_limiter","rhs_needed"]);
      if(hasLegacy) return resistorPath("truck_pre2015");
      return R([],"no_module","truck_no_magneride",[]);
    }

    /* ── GATE 3: SUVs ────────────────────────────────────────────────────
       The only body type where air leveling exists. */

    // 3a. Pre-2015. The OBD/SS Legacy covers 2007-2014 SUVs with MagneRide.
    // It is a full Suspension Control Module emulator, which is why it never
    // carries the Ride Height Simulator note and never carries the air line
    // loop note: on these SUVs the air data routes through the SCM, so
    // emulating the SCM covers the air system too.
    if(year<=2014){
      var legacyFit = (hasMR || hasLegacy) && inRange(year, SUV_LEGACY_RANGE);

      if(legacyFit && ENABLED.LEGACY)
        return R([opt("LEGACY")],"ok","legacy_era",
          ["legacy_full_emulation","legacy_all_four","speed_limiter"]);

      // Legacy is not live yet, or the SUV is older than the Legacy covers.
      // Either way the answer is the resistor method, and because these SUVs
      // always have rear air leveling they also need the air line loop and
      // the ALC bypass video. That air wording stays on the SUV path only.
      if(hasMR || hasLegacy){
        var suvDiyNotes = ["z55_resistors","z55_ziptie","z55_why",
          "resistor_overcurrent","alc_bypass"];
        if(legacyFit)
          return R([],"diy","legacy_tester_wanted",
            ["legacy_tester"].concat(suvDiyNotes));
        return R([],"diy","suv_pre2015_no_module", suvDiyNotes);
      }
      return R([],"no_module","suv_no_magneride",["suv_air_no_mr"]);
    }

    // 3b. No MagneRide means no module, now or ever. Air may still be
    // present and we cannot see it in the codes, so cover it in the advice.
    if(!hasMR){
      if(air==="nivomat") return R([],"no_module","nivomat_no_module",["nivomat_springs"]);
      return R([],"no_module","suv_no_magneride",["suv_air_no_mr"]);
    }

    // 3c. Air Ride Adaptive Suspension (RPO F47). One product, two versions:
    // 2021-2024 is the Elite, 2025 and newer is the EliteV2 variant. Both link
    // to the main Elite page; the pick note says which year option to choose.
    if(hasF47){
      if(inRange(year,SUV_ELITE_RANGE)){
        if(year < ELITE_V2_MIN_YEAR)
          return R([opt("ELITE",{notes:["elite_pick_v1"]})],"ok","suv_f47",["air_all_four"]);
        if(ENABLED.ELITE_V2)
          return R([opt("ELITE",{variantKey:"ELITE_V2",notes:["elite_pick_v2"]})],"ok","suv_f47",["air_all_four"]);
      }
      return R([],"unsupported","suv_air_2025_plus",[]);
    }

    // 3d. 2021 and newer with MagneRide and no air ride.
    if(year>=SUV_ELITE_RANGE.minYear)
      return R([opt("CARBON",{useAirBlurb:true})],"ok","suv_carbon",["carbon_no_f47","speed_limiter"]);

    // 3e. 2015-2020 with MagneRide. On this platform that always means rear
    // air is present, so the customer chooses: keep the air, or delete it.
    if(inRange(year,SUV_CLASSIC_RANGE)){
      /* The Classic notes depend on whether the Apex is live. With the Apex
         live the Classic is purely the keep the air option, so the ALC bypass
         video and the air line wording come off it and anyone who wants the
         air gone is sent to the Apex. With the Apex not live the Classic is
         the only module on this platform, so it has to keep carrying the air
         line instructions. */
      var classicOpt = opt("CLASSIC",{
        headline:"Keep the rear air leveling",
        useAirBlurb:true,
        notes: ENABLED.APEX
          ? ["classic_keeps_air_apex","front_or_rear_sets","rhs_needed","towing_air"]
          : ["classic_keeps_air","front_or_rear_sets","alc_bypass","rhs_needed","towing_air"]
      });
      if(ENABLED.APEX){
        // Apex emulates the SCM, including ride height, so it must never
        // carry the Ride Height Simulator note.
        var apexOpt = opt("APEX",{
          headline:"Delete the air system",
          notes:["apex_deletes_air","apex_no_rhs","towing_air"]
        });
        return R([apexOpt,classicOpt],"ok","suv_two_options",["speed_limiter"]);
      }
      return R([classicOpt],"ok","apex_not_live",["apex_coming","speed_limiter"]);
    }

    // Anything left over on an SUV.
    return R([],"no_module","suv_no_magneride",["suv_air_no_mr"]);
  }

  /* ---- Ford and Lincoln. No Worker call, year straight off the VIN. ---- */
  function recommendFord(vin){
    var year = vinModelYear(vin);
    if(year && year>=FORD_SUPPORT.minYear && year<=FORD_SUPPORT.maxYear){
      return { options:[{ product:"VDME", variantKey:null, headline:null,
        useAirBlurb:false, notes:["ford_models"] }],
        status:"ok", reason:"ford_supported", notes:[], air:null };
    }
    return { options:[], status:"unsupported",
      reason: year ? "ford_out_of_range" : "year_unknown",
      notes:["ford_models"], air:null };
  }

  /* ---- shared HTML builders ---- */
  function vehicleHeader(data){
    if(!data || !data.vehicle) return "";
    var s=esc(data.vehicle);
    if(data.trim) s+=' <span class="ss-fit__trim">Trim: '+esc(data.trim)+'</span>';
    return '<p class="ss-fit__vehicle">'+s+'</p>';
  }
  function buildSummary(data, rec){
    var codes=(data&&data.suspension)||[];
    var h='';
    if(codes.length){
      h+='<p class="ss-fit__eyebrow">'+esc(T.buildEyebrow)+'</p><ul class="ss-fit__codes">';
      codes.forEach(function(c){
        h+='<li class="ss-fit__codeRow ss-fit__codeRow--'+esc(c.group)+'">'
          +'<span class="ss-fit__code">'+esc(c.code)+'</span>'
          +'<span class="ss-fit__codeBody"><span class="ss-fit__codeName">'+esc(c.label)+'</span>'
          +'<span class="ss-fit__desc">'+esc(c.detail)+'</span></span></li>';
      });
      h+='</ul>';
    }
    // Air line is SUV only. rec.air is null on car, truck and Ford paths.
    if(rec && rec.air && AIR_SUMMARY[rec.air]){
      h+='<p class="ss-fit__airline"><span class="ss-fit__airTag">'+esc(T.airEyebrow)+'</span>'
        +'<span>'+esc(AIR_SUMMARY[rec.air])+'</span></p>';
    }
    return h;
  }
  function noteHtml(key){
    var n=NOTES[key]; if(!n) return "";
    var h='<p class="ss-fit__note">'+esc(n.text);
    if(n.link) h+=' <a class="ss-fit__link" href="'+esc(n.link.href)+'" target="_blank" rel="noopener">'+esc(n.link.label)+'</a>';
    return h+'</p>';
  }
  function notesHtml(keys){ return (keys||[]).map(noteHtml).join(""); }
  function contactLinks(){
    return '<p class="ss-fit__foot"><a class="ss-fit__link" href="'+esc(CONTACT_URL)+'">'+esc(T.contactText)+'</a>'
      +'<span class="ss-fit__dot">\u00B7</span><a class="ss-fit__link" href="'+esc(SUPPORTED_URL)+'">'+esc(T.supportedText)+'</a></p>';
  }
  /* ---- GM window sticker fallback card ----
     Returns a warning card with the window sticker link, or "" when the VIN is
     not a GM 2021+ build (the only range this fallback is offered for). Shown
     when the RPO service cannot decode the VIN, usually because the model year
     is too new to be in the database yet. The link opens in a new tab. ---- */
  function gmStickerCard(vin){
    var year = vinModelYear(vin);
    if(detectMake(vin) !== "GM" || !year || year < 2021) return "";
    return '<div class="ss-fit__card ss-fit__card--warn">'
      + '<p class="ss-fit__note">' + esc(MESSAGES.window_sticker_hint)
      + ' <a class="ss-fit__link" href="' + esc(WINDOW_STICKER_URL) + encodeURIComponent(vin)
      + '" target="_blank" rel="noopener">' + esc(T.windowStickerLink) + '</a></p>'
      + contactLinks() + '</div>';
  }
  /* ---- live product data written into the page by the Liquid snippet ---- */
  var LIVE = null;
  function liveData(){
    if(LIVE) return LIVE;
    LIVE = {};
    var tag = document.getElementById("ss-fit-products");
    if(tag){
      try { LIVE = JSON.parse(tag.textContent || "{}") || {}; }
      catch(e){ LIVE = {}; }
    }
    return LIVE;
  }
  function liveFor(product){
    var d = product.handle ? liveData()[product.handle] : null;
    return d || null;
  }

  function buildProductUrl(product,o,vin,live){
    var url=(live && live.url) || product.url;
    if(product.variants && o.variantKey && product.variants[o.variantKey]){
      url+="?variant="+product.variants[o.variantKey];
      if((product.autofillVinFor||[]).indexOf(o.variantKey)!==-1) url+="&vin="+encodeURIComponent(vin);
    }
    return url;
  }
  function displayTitle(product,o,live){
    // A variant name wins, so a 2023 truck reads "OBD/SS ARC-R" instead of
    // the parent product title.
    if(product.variantNames && o.variantKey && product.variantNames[o.variantKey])
      return product.variantNames[o.variantKey];
    return (live && live.title) || product.name;
  }
  function optionHtml(o, vin, showHeadline){
    var p=PRODUCTS[o.product]; if(!p) return "";
    var live = liveFor(p);
    var href = buildProductUrl(p,o,vin,live);
    var title = displayTitle(p,o,live);
    var img   = live && live.image;

    var h='<div class="ss-fit__opt">';
    if(showHeadline && o.headline) h+='<p class="ss-fit__optHead">'+esc(o.headline)+'</p>';

    h+='<a class="ss-fit__prod" href="'+esc(href)+'">';
    if(SHOW_IMAGE && img)
      h+='<img class="ss-fit__thumb" src="'+esc(img)+'" alt="" loading="lazy" width="64" height="64">';
    h+='<span class="ss-fit__prodMeta"><span class="ss-fit__rec">'+esc(title)+'</span>';
    if(SHOW_PRICE && live && live.price) h+='<span class="ss-fit__price">'+esc(live.price)+'</span>';
    h+='</span></a>';

    var blurb = (o.useAirBlurb && p.blurbAir) ? p.blurbAir : p.blurb;
    if(blurb) h+='<p class="ss-fit__note">'+esc(blurb)+'</p>';
    h+=notesHtml(o.notes);
    h+='<a class="ss-fit__cta" href="'+esc(href)+'">'+esc(p.cta||"View product")+'</a>';
    return h+'</div>';
  }
  function resultHtml(data, rec){
    var vin=(data&&data.vin)||"";
    /* ---- Fitment attribution ------------------------------------------
       Every outcome renders through here, so this is the only hook needed.
       Debug runs are excluded so a test scenario can never reach a real
       order. Null-guarded throughout: the Ford path passes {vin:vin} alone
       and carries no rec.signals. ---- */
    if (window.SSFitment && vin && !/[?&]ssfit_debug=1/.test(window.location.search)) {
      var ssTop = (rec && rec.options && rec.options[0]) || null;
      var ssRec = null;
      if (ssTop && PRODUCTS[ssTop.product]) {
        var ssP = PRODUCTS[ssTop.product];
        ssRec = (ssP.variantNames && ssTop.variantKey && ssP.variantNames[ssTop.variantKey])
                || ssP.name;
      }
      window.SSFitment.setVIN(vin, {
        vehicle: data && data.vehicle,
        trim:    data && data.trim,
        year:    (rec && rec.signals && rec.signals.year) || (data && data.year) || vinModelYear(vin),
        engine:  rec && rec.signals && rec.signals.engine,
        rpo:     ((data && data.suspension) || []).map(function(c){ return c.code; }).join(', '),
        recommends: ssRec,
        outcome: rec && rec.status
      });
    }
    var summary=buildSummary(data,rec);
    var divider=summary?'<hr class="ss-fit__divider">':"";
    var h='';
    if(rec.status==="ok" && rec.options.length){
      var multi = rec.options.length>1;
      h+='<div class="ss-fit__card ss-fit__card--rec">';
      h+=vehicleHeader(data)+summary+divider;
      h+='<p class="ss-fit__eyebrow">'+esc(multi?T.twoOptionsEyebrow:T.recommendedEyebrow)+'</p>';
      if(multi && MESSAGES[rec.reason]) h+='<p class="ss-fit__note">'+esc(MESSAGES[rec.reason])+'</p>';
      h+='<div class="ss-fit__opts'+(multi?' ss-fit__opts--multi':'')+'">';
      rec.options.forEach(function(o){ h+=optionHtml(o,vin,multi); });
      h+='</div>';
      if(!multi && MESSAGES[rec.reason]) h+='<p class="ss-fit__note ss-fit__note--aside">'+esc(MESSAGES[rec.reason])+'</p>';
      h+=notesHtml(rec.notes)+contactLinks()+'</div>';
      return h;
    }
    var msg = MESSAGES[rec.reason] || STATUS_FALLBACK[rec.status] || STATUS_FALLBACK.no_module;
    var cardMod = (rec.status==="needs_vin" || rec.status==="unsupported") ? " ss-fit__card--warn" : "";
    return '<div class="ss-fit__card'+cardMod+'">'+vehicleHeader(data)+summary+divider
      +'<p class="ss-fit__note">'+esc(msg)+'</p>'+notesHtml(rec.notes)+contactLinks()+'</div>';
  }

  /* ══════════════════════════════════════════════════════════════════════
     Per-instance wiring. Scoped by class, so several widgets can live on one
     page and nothing depends on script order.
     ══════════════════════════════════════════════════════════════════════ */
  function initWidget(root){
    if(root.dataset.ssFitReady === "1") return;
    root.dataset.ssFitReady = "1";

    var vinEl = root.querySelector(".ss-fit__input");
    var btn   = root.querySelector(".ss-fit__btn");
    var out   = root.querySelector(".ss-fit__out");
    if(!vinEl || !btn || !out) return;

    /* aria-busy is the machine-readable "still working" flag. The spinner is
       only a picture, and a disabled button is ambiguous. Browser agents and
       screen readers both key their wait behaviour off this attribute, so an
       agent that clicks Check fitment can tell the difference between "the
       click did nothing" and "the VIN decode is still running". */
    function setBusy(b){
      btn.disabled=b;
      btn.textContent=b?"Checking\u2026":"Check fitment";
      out.setAttribute("aria-busy", b?"true":"false");
    }
    /* Coverage note, above the results. Set T.coverageNote to "" to hide it. */
    if(T.coverageNote && !root.querySelector(".ss-fit__coverage")){
      var cov = document.createElement("p");
      cov.className = "ss-fit__note ss-fit__coverage";
      cov.textContent = T.coverageNote;
      out.parentNode.insertBefore(cov, out);
    }

    function renderError(msg){ out.innerHTML='<div class="ss-fit__card"><p class="ss-fit__err">'+esc(msg)+'</p></div>'; }
    function loadingHtml(text){
      return '<div class="ss-fit__card"><p class="ss-fit__loading" role="status"><span class="ss-fit__spinner" aria-hidden="true"></span>'+esc(text)+'</p></div>';
    }

    function check(){
      var vin=vinEl.value.trim().toUpperCase(); vinEl.value=vin;
      if(!VIN_RE.test(vin)){ renderError(T.badVin); return; }

      var make=detectMake(vin);

      /* Ford and Lincoln are answered locally. */
      if(make==="FORD" || make==="LINCOLN"){
        out.innerHTML=resultHtml({vin:vin}, recommendFord(vin));
        return;
      }
      /* Anything that is not GM has no RPO list to fetch, so we never call
         the Worker for it. */
      if(make!=="GM"){
        out.innerHTML=resultHtml({vin:vin},
          { options:[], status:"unsupported", reason:"unsupported_make", notes:[], air:null });
        return;
      }

      setBusy(true);
      out.innerHTML = loadingHtml(T.loading);

      /* If DecoderPro is going to hand off to the window sticker, it will have
         timed out by now, so swap the status text. Armed only for GM VINs new
         enough to have a sticker fallback, and cleared the moment the response
         arrives (below) so a fast DecoderPro answer never sees it. */
      var hintTimer = null, hintYear = vinModelYear(vin);
      if(hintYear && hintYear >= STICKER_HINT_MIN_YEAR){
        hintTimer = setTimeout(function(){
          if(out.getAttribute("aria-busy") === "true") out.innerHTML = loadingHtml(T.loadingSticker);
        }, STICKER_HINT_DELAY_MS);
      }

      fetch(SS_FIT_WORKER_URL+encodeURIComponent(vin), { method:"GET", headers:{ "Accept":"application/json" } })
        .then(function(r){ if(hintTimer) clearTimeout(hintTimer); return r.json(); })
        .then(function(data){
          if(data.error && !data.rpo){
            // A too-new GM VIN the decoder does not have yet: offer the window
            // sticker before falling back to the raw service error.
            var card = gmStickerCard(vin);
            if(card){ out.innerHTML = card; } else { renderError(data.error); }
            return;
          }
          var rpo = data.rpo || [];
          var dataYear = data.year || vinModelYear(vin);
          if(!rpo.length && dataYear && dataYear < GM_VIN_MIN_YEAR){
            out.innerHTML = resultHtml({vin:vin, vehicle:data.vehicle, trim:data.trim, year:dataYear},
              { options:[], status:"needs_vin", reason:"gm_pre_coverage", notes:[], air:null });
            return;
          }
          if(!rpo.length){
            out.innerHTML = gmStickerCard(vin) || resultHtml({vin:vin},
              { options:[], status:"needs_vin", reason:"no_decode", notes:[], air:null });
            return;
          }
          var codes = rpo.map(function(x){ return x.code; });
          var year = data.year || vinModelYear(vin);
          data.vin = vin; 
          // Codes are filtered to the ones that actually apply to this body
          // style and year, so a Terrain never reads back "base Stingray".
          data.suspension = suspensionRows(codes, scopeCtx(data.vehicle, year));
          out.innerHTML=resultHtml(data, recommend({ vin:vin, year:year, vehicleTitle:data.vehicle, codes:codes }));
        })
        .catch(function(){ renderError(T.unreachable); })
        .then(function(){ setBusy(false); });
    }

    /* ---- debug scenario runner: only with ?ssfit_debug=1 in the URL ---- */
    function runTestCase(tc){
      var data = { vin:tc.vin, vehicle:tc.vehicle, trim:tc.trim, year:tc.year,
        suspension: suspensionRows(tc.codes, scopeCtx(tc.vehicle, tc.year)) };
      out.innerHTML = resultHtml(data, recommend({
        vin:tc.vin, year:tc.year, vehicleTitle:tc.vehicle, codes:tc.codes }));
    }
    if(/[?&]ssfit_debug=1/.test(window.location.search)){
      var bar = document.createElement("div");
      bar.className = "ss-fit__debug";
      bar.innerHTML = '<p class="ss-fit__debugTitle">Test scenarios (no Worker call)</p>';
      TEST_CASES.forEach(function(tc){
        var b = document.createElement("button");
        b.type = "button"; b.className = "ss-fit__debugBtn"; b.textContent = tc.name;
        b.addEventListener("click", function(){ vinEl.value = tc.vin; runTestCase(tc); });
        bar.appendChild(b);
      });
      // Ford path is local, so give it a button too.
      var fb = document.createElement("button");
      fb.type="button"; fb.className="ss-fit__debugBtn"; fb.textContent="2019 Navigator (Ford path)";
      fb.addEventListener("click", function(){
        var v="5LMJJ2LT0KEL00001"; vinEl.value=v;
        out.innerHTML=resultHtml({vin:v, vehicle:"2019 Lincoln Navigator"}, recommendFord(v));
      });
      bar.appendChild(fb);
      var fb2 = document.createElement("button");
      fb2.type="button"; fb2.className="ss-fit__debugBtn"; fb2.textContent="2025 Navigator (out of range)";
      fb2.addEventListener("click", function(){
        var v="5LMJJ2LT0SEL00001"; vinEl.value=v;
        out.innerHTML=resultHtml({vin:v, vehicle:"2025 Lincoln Navigator"}, recommendFord(v));
      });
      bar.appendChild(fb2);
      // GM window sticker fallback: a too-new GM VIN the decoder cannot read.
      var wb = document.createElement("button");
      wb.type="button"; wb.className="ss-fit__debugBtn"; wb.textContent="2026 GM VIN (window sticker)";
      wb.addEventListener("click", function(){
        var v="1GNSKNKD0TR000001"; vinEl.value=v;
        out.innerHTML = gmStickerCard(v) || resultHtml({vin:v},
          { options:[], status:"needs_vin", reason:"no_decode", notes:[], air:null });
      });
      bar.appendChild(wb);
      // Older GM VIN: the Worker has no RPO source for it (interim coverage).
      var pb = document.createElement("button");
      pb.type="button"; pb.className="ss-fit__debugBtn"; pb.textContent="2019 GM VIN (before VIN coverage)";
      pb.addEventListener("click", function(){
        var v="1GNSKJKC6KR147302"; vinEl.value=v;
        out.innerHTML = resultHtml({vin:v, vehicle:"2019 CHEVROLET Tahoe", trim:"Premier", year:2019},
          { options:[], status:"needs_vin", reason:"gm_pre_coverage", notes:[], air:null });
      });
      bar.appendChild(pb);
      out.parentNode.insertBefore(bar, out);
    }

    btn.addEventListener("click", check);
    vinEl.addEventListener("keydown", function(e){ if(e.key==="Enter"){ e.preventDefault(); check(); } });
    vinEl.addEventListener("input", function(){
      this.value=this.value.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g,"").slice(0,17);
    });

    /* Handle used by the ?vin= deep link below. */
    root.ssFitRun = function(vin){ vinEl.value = vin; check(); };
  }

  /* ---- popup wiring ---- */
  var SS_MODALS = [];

  function initModal(wrap){
    if(wrap.dataset.ssFitModalReady === "1") return;
    wrap.dataset.ssFitModalReady = "1";

    var opener  = wrap.querySelector(".ss-fit-open");
    var overlay = wrap.querySelector(".ss-fit-overlay");
    var closer  = wrap.querySelector(".ss-fit-close");
    var vinEl   = wrap.querySelector(".ss-fit__input");
    if(!overlay) return;
    var lastFocus=null;

    function open(){
      lastFocus=document.activeElement;
      overlay.hidden=false;
      document.documentElement.classList.add("ss-fit-locked");
      if(vinEl) setTimeout(function(){ try{ vinEl.focus(); }catch(e){} },40);
    }
    function close(){
      overlay.hidden=true;
      document.documentElement.classList.remove("ss-fit-locked");
      if(lastFocus && lastFocus.focus) lastFocus.focus();
    }
    if(opener) opener.addEventListener("click", function(e){ e.preventDefault(); open(); });
    if(closer) closer.addEventListener("click", function(e){ e.preventDefault(); close(); });
    overlay.addEventListener("click", function(e){ if(e.target===overlay) close(); });
    document.addEventListener("keydown", function(e){ if(e.key==="Escape" && !overlay.hidden) close(); });
    SS_MODALS.push({ open:open, close:close });
  }

  /* ---- Open the popup from any link, anywhere on the site ----
     Put <a href="#ss-fit">Find your module</a> in any page, blog post,
     rich text block, menu item or button. No Liquid needed at the link.
     Also works on any element with data-ss-fit-open. ---- */
  var OPEN_SELECTOR = 'a[href="#ss-fit"], a[href$="#ss-fit"], [data-ss-fit-open]';
  document.addEventListener("click", function(e){
    var t = e.target && e.target.closest ? e.target.closest(OPEN_SELECTOR) : null;
    if(!t) return;
    if(!SS_MODALS.length) return;   // no popup on this page, let the link behave normally
    e.preventDefault();
    SS_MODALS[0].open();
  });

  /* ---- Deep link:  /pages/find-your-module?vin=1GNSKJKC5KR123456 ----------
     Turns a fitment result into an address. Anyone can share the link and
     land on the answer: support in an email, a customer to a friend, and
     crucially an AI agent, which can construct the URL directly instead of
     opening a modal, typing 17 characters, and guessing how long to wait.

     Scoping rules, so this never hijacks a page it should not:
       - An INLINE widget is already on screen, so just run it.
       - A page with no inline widget only gets the popup forced open when
         the link explicitly asked for it with the #ss-fit hash. This matters
         because product pages already use ?vin= to prefill their own VIN
         checker, and that must not pop this modal over the buy button.
     -------------------------------------------------------------------- */
  var SS_DEEPLINK_DONE = false;

  function deepLinkVin(){
    if(SS_DEEPLINK_DONE) return;

    var v = "";
    try {
      v = (new URLSearchParams(window.location.search).get("vin") || "")
            .toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g,"").slice(0,17);
    } catch(e){ return; }
    if(!VIN_RE.test(v)) return;

    var i, els = document.querySelectorAll(".ss-fit"), ran = false;
    for(i=0;i<els.length;i++){
      var el = els[i];
      if(el.closest && el.closest(".ss-fit-overlay")) continue;  /* modal copy */
      if(typeof el.ssFitRun === "function"){ el.ssFitRun(v); ran = true; }
    }
    if(ran){ SS_DEEPLINK_DONE = true; return; }

    if(window.location.hash === "#ss-fit" && SS_MODALS.length){
      SS_MODALS[0].open();
      var m = document.querySelector(".ss-fit-overlay .ss-fit");
      if(m && typeof m.ssFitRun === "function"){ m.ssFitRun(v); SS_DEEPLINK_DONE = true; }
    }
  }

  function boot(){
    var i, els;
    els = document.querySelectorAll(".ss-fit");
    for(i=0;i<els.length;i++) initWidget(els[i]);
    els = document.querySelectorAll(".ss-fit-wrap");
    for(i=0;i<els.length;i++) initModal(els[i]);
    deepLinkVin();
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  // Shopify theme editor re-renders sections without a page reload.
  document.addEventListener("shopify:section:load", boot);
  window.ssFitBoot = boot;   // call ssFitBoot() from the console to re-scan
})();